module.exports = __webpack_public_path__ + "img/ingredients-portrait-x1.49b4976c.jpg";